import { FC } from 'react';
import Joyride, { CallBackProps, Locale, Step } from 'react-joyride';
import { AIGenerationTourTooltip } from './AIGenerationTourTooltip';
import { AI_GENERATION_TOUR_FLOATER_PROPS, AI_GENERATION_TOUR_JOYRIDE_STYLES } from './AIGenerationTour.constants';

interface AIGenerationTourProps {
    steps: Step[];
    run: boolean;
    locale: Locale;
    onCallback: (data: CallBackProps) => void;
}

export const AIGenerationTour: FC<AIGenerationTourProps> = ({ steps, run, locale, onCallback }) => (
    <Joyride
        steps={steps}
        run={run}
        continuous
        showSkipButton
        disableScrolling
        scrollToFirstStep={false}
        disableOverlayClose
        callback={onCallback}
        locale={locale}
        tooltipComponent={AIGenerationTourTooltip}
        floaterProps={AI_GENERATION_TOUR_FLOATER_PROPS}
        styles={AI_GENERATION_TOUR_JOYRIDE_STYLES}
    />
);
